module.exports = __webpack_public_path__ + "static/media/rubricas.6519728d.png";